import { CategoryType, CategoryTypeToEntity } from '../shared/types';

export interface Category {
  readonly categoryType: CategoryType;
  readonly categoryId: string;
  readonly parent: Category | undefined;
}

export class ConcreteCategory<T extends CategoryType> implements Category {
  readonly categoryType: T;
  readonly categoryId: string;
  readonly categoryHumanId: string;
  readonly categoryDisplayName: string;
  readonly parent: Category | undefined;
  readonly entity: CategoryTypeToEntity[T] | undefined;

  constructor(
    categoryType: T,
    categoryId: string,
    categoryHumanId: string,
    categoryDisplayName: string,
    entity: CategoryTypeToEntity[T],
    inherited: Category | undefined
  ) {
    this.categoryType = categoryType;
    this.categoryId = categoryId;
    this.categoryHumanId = categoryHumanId;
    this.categoryDisplayName = categoryDisplayName;
    this.entity = entity;
    this.parent = inherited;
  }

  /**
   * Returns an array containing this category and all its inherited categories recursively.
   * The array will contain all parent/inherited categories until the inherited property is null or undefined.
   */
  getAllCategories(): Category[] {
    const categories: Category[] = [this];

    let parent = this.parent;
    while (parent) {
      categories.push(parent);
      parent = parent.parent;
    }

    return categories;
  }
}
